module.exports = __webpack_public_path__ + "media/images/profile_logo/thumbs_empty_member-3409d54172ec1919dfc520ac7eb7eb6d.png";